export { kompendium } from './generator';
